import { BcodeSDK } from '@bcode-tech/bcode-sdk';
import { pablockApiKey, pablockConfig } from './constants';

export const bcodeSDK = BcodeSDK.createLegacy({
  apiKey: pablockApiKey || '',
  config: pablockConfig,
});
